"use client"

import { ChevronRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChevronRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChevronRightIcon = component(Icon)({ as: ChevronRight })
